// What's New — feature spotlight on its own route.
import { C, SectionLabel, PublicPage } from "@/components/PublicShell";
import { WhatsNewSection } from "@/components/WhatsNewSection";

export default function WhatsNewPage() {
  return (
    <PublicPage>
      <section className="py-16 px-5" data-testid="whats-new-page">
        <div className="max-w-5xl mx-auto">
          <SectionLabel text="What&apos;s new" color={C.muted} />
          <h1 className="text-xl sm:text-2xl font-extrabold tracking-tight mb-10" style={{ color: C.text }}>
            Beyond the chain. Beyond entry. Beyond intuition.
          </h1>
          <WhatsNewSection C={C} />
        </div>
      </section>
    </PublicPage>
  );
}
